import React, { lazy, Suspense, useEffect } from 'react';
import CreateContextAiquireProvider from '../../CreateContextAiquire/CreateContextAiquire'; 
import { FullScreenSpinner } from '../../components/shared/Spinner';
import PermissionNotAllowed from '../../components/shared/PermissionNotAllowed';
import { useDispatch } from 'react-redux';
import { setActiveFolderCreate } from '../../store/actions';
import './index.scss';

export default function AiquireDesignOnboarding({ userPermissions }:any) {
  const AiquireDesignOnboarding = lazy(() => import('../../components/DesignOnboarding'))
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {dispatch(setActiveFolderCreate({ folder: 0 }))};
  });
  
  return userPermissions.includes('create-new-banners') ? (
    <CreateContextAiquireProvider>
      <Suspense fallback={<FullScreenSpinner />}>
        <AiquireDesignOnboarding />
      </Suspense>
    </CreateContextAiquireProvider>
  ) : (
    <div className="aiquire-create-permission-container">
      <PermissionNotAllowed title="You do not have access to this feature as per your role" />
    </div>
  )
}